import styled from 'styled-components';

export const EmptyContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
export const EmptyListImage = styled.img`
  width: 20%;
  max-width: 182px;
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  font: var(--font-large-20);
  margin: 0;
`;

export const SubTitle = styled.p`
  font: var(--font-regular-15);
  color: var(--color-grey-11_60);
  margin: 0;
`;
